import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ImmoOverviewStateService } from 'src/app/services/immo-overview-state.service';

@Component({
  selector: 'appointment-immo-overview',
  templateUrl: './appointment-immo-overview.component.html',
  styleUrls: [
    '../immo-print-tables/immo-print-tables.component.scss',
    '../abstract-immo-overview.component.scss'
  ]
})
export class AppointmentImmoOverviewComponent implements OnInit {
  @Output()
  countChange = new EventEmitter<number>();

  selectedOverview: string;

  countNew: number = 0;
  countNoTour: number = 0;
  countDelayed: number = 0;

  constructor(private immoOverviewStateService: ImmoOverviewStateService) {}

  ngOnInit() {
    this.selectedOverview = this.immoOverviewStateService.getSelectedAppointmentView();
  }

  changeSelectedView(value: string): void {
    this.selectedOverview = value;
    this.immoOverviewStateService.setSelectedAppointmentView(value);
  }

  updateNewCount(count: number): void {
    this.countNew = count;
    this.emitSummedCount();
  }

  updateNoTourCount(count: number): void {
    this.countNoTour = count;
    this.emitSummedCount();
  }

  updateDelayedCount(count: number): void {
    this.countDelayed = count;
    this.emitSummedCount();
  }

  emitSummedCount(): void {
    const summedCount: number =
      this.countNew + this.countNoTour + this.countDelayed;
    this.countChange.emit(summedCount);
  }
}
